<div id="wrapper">
  
  <header><div>CCXXXIX </div></header>

<article>
    <mat-tab-group mat-align-tabs="start">
      <mat-tab label="SA"><app-schlossanger></app-schlossanger></mat-tab>
      <mat-tab label="&Delta;  |   &Delta;   Holzar"><app-kultur></app-kultur></mat-tab>
      <mat-tab label="RH"><app-reinhried></app-reinhried></mat-tab>
      <mat-tab label="ToDo"><app-app-todo></app-app-todo></mat-tab>
    </mat-tab-group>
  </article>
 </div>
  <footer><img src="../../assets/holzmark.svg" width="180px" height="180px">CCXXXIX<a href="./assets/3rdpartylicenses.txt">Lizenzen</a> 
    <a href="./assets/impressum.txt">Impressum</a></footer>

